<template>
    <div>
        <div class="header">
             <span ></span>
             <span>补充资料</span>
             <span @click="closeHan" style="line-height: 50px;"><van-icon name="close" size="24" /></span>
        </div>
        <div class="con">
            <van-form @submit="onSubmit">
                <van-field name="uploader" label="主图"  >
                    <template #input>
                        <!-- <div class="content-up">
                            <div v-if="!isWechat">
                                <van-uploader v-model="fileList1" :after-read="uploadershang('zhu')" :before-delete="deleteimg('zhu')"
                                    preview-size="100%" :max-count="1">
                                    <img style="width:100%" src="../../assets/zhanwu.jpg" alt="" @click="WeChooseImage(1, '45Degrees')">
                                </van-uploader>
                            </div>
                            <div v-else>
                                <img v-if="!imageUrl" style="width:100%" src="../../assets/zhanwu.jpg" alt=""
                                    @click="WeChooseImage(1, '45Degrees')">

                                <div v-else style="width:100%">
                                    <van-image class="vanImage" style="width:100%" :src="imageUrl" @click="bigImg(imageUrl)">
                                        <van-icon class="iconX" name="close" @click.stop="delImgHan('45Degrees')" />
                                    </van-image>
                                </div>
                            </div>
                        </div> -->
                        <uploads num="1" type="1"  ref="imgChangeRef1" @imagesUrl="imagesUrl" />
                    </template>
                </van-field>
                <van-field name="uploader" label="铭牌">
        
                    <template #input>
                        <div class="content-up">
                            <!-- <div v-if="!isWechat">
                                <van-uploader v-model="fileList2" :after-read="uploadershang('min')" :before-delete="deleteimg('min')"
                                    preview-size="100%" :max-count="1">
                                    <img style="width:100%" src="../../assets/zhanwu.jpg" alt="" @click="WeChooseImage(1, 'Vin')">
                                </van-uploader>
                            </div>
                            <div v-else>
                                <img v-if="!imageUrl" style="width:100%" src="../../assets/zhanwu.jpg" alt=""
                                    @click="WeChooseImage(1, 'Vin')">

                                <div v-else style="width:100%">
                                    <van-image class="vanImage" style="width:100%" :src="imageUrl" @click="bigImg(imageUrl)">
                                        <van-icon class="iconX" name="close" @click.stop="delImgHan('Vin')" />
                                    </van-image>
                                </div>
                            </div> -->
                            <uploads num="1" type="2" ref="imgChangeRef2" @imagesUrl="imagesUrl" />
                        </div>
                    </template>
                </van-field>
               
               
                <van-field v-model="form.mileage" type="number"  label="里程数"    placeholder="请输入里程数" />
                <van-field v-model="form.vehicle_sales_price" type="number"   label="全车件售价"  placeholder="请输入全车件售价" />
                <van-field v-model="form.dismantling_costs" type="number"  label="拆解费用"  placeholder="请输入拆解费用" />
                <van-field readonly clickable name="datetimePicker"   :value="form.sales_deadline"  label="截止销售日期" placeholder="点击选择截止销售日期"  @click="timeChange(1)" />
                <van-field readonly clickable name="datetimePicker"   :value="form.dismantling_deadline"  label="截止拆解日期" placeholder="点击选择截止拆解日期"  @click="timeChange(2)" />
                    <van-popup v-model="showPicker" position="bottom">
                        <van-datetime-picker
                            type="date"
                            v-model="newDate"
                            :formatter="formatter"
                            @confirm="onConfirm"
                            @cancel="showPicker = false"
                        />
                    </van-popup>
                <van-field name="uploader" label="多角度照片"  >
                        <template #input>
                            <!-- <div v-if="!isWechat">
                                <van-field name="uploader" >
                                    <template #input>
                                        <van-uploader v-model="imageFile" :after-read="uploadershang('restsImg')" :before-read="beforeRead" 
                                            multiple :before-delete="deleteimg2"></van-uploader>
                                    </template>
                                </van-field>
                            </div>

                            <div class="upimg" v-else>
                                <p>
                                    <span class="imgbox" v-for="(item, index) in WXimg" :key="index">
                                        <van-image class="vanImage" width="80" height="80" :src="item" @click="bigImg(item)">
                                            <van-icon class="iconX" name="close" @click="delImgHan('arrPhoto', index)" />
                                        </van-image>
                                    </span>
                                    <span class="uploaderImg" @click="WeChooseImage(9)">
                                        <van-icon class="iconz" name="plus" />
                                    </span>
                                </p>
                            </div> -->
                            <uploads num="20" type="3"  ref="imgChangeRef3" @imagesUrl="imagesUrl" @closeArr="closeArr" />
                        </template>
                </van-field>
                <van-field v-model="form.scrap_reason" type="test"   label="报废原因"  placeholder="请输入报废原因" />

                <div style="margin: 16px;">
                    <van-button round block type="info" native-type="submit">提交</van-button>
                </div>
            </van-form>
        </div>
        
    </div>
</template>


<script>
import moment from 'moment'
import uploads from '@/components/upload/uploads'
import {zhbAdd,zhbIdentify,getZhbInfo} from '@/api/api'
import {Toast} from 'vant'
    export default {
        components: {
            uploads
        },
        data() {
            return {
                form:{
                    vehicle_tag:"",//  #铭牌
                    mileage:"",//  里程数必须是数字   #里程数
                    main_photo:"",//  #主图
                    photos:[],//  #车辆多角度照片
                    scrap_reason:"",//  #报废原因
                    vehicle_sales_price:"",//   #全车件售价
                    dismantling_costs:"",//  #拆解费用
                    sales_deadline:"",//  截止销售日期
                    dismantling_deadline:"",//   #截止拆解日期（购买整车件最晚拆解时间）
                },
                imageFile: [],//其他照片
                wximagelocalids: [],//判断上传张数
                WXimg: [],//其他照片
                fileList1:[],
                fileList2:[],
                imageUrl: "",//45度
                VinUrl:"",
                showPicker:false,//时间
                newDate:new Date(),
                timeId:0,
                infoId:'',
                idsInfo:1
            }
        },
        mounted () {
           
        },
        watch: {
            wximagelocalids: {
                handler(newValue, oldValue) {
                    if (newValue.length > 0) {
                        this.toast = Toast.loading({
                            duration: 0, // 持续展示 toast
                            forbidClick: true,
                            message: "上传中..."
                        });
                        this.wxUpload(newValue[0])
                    } else {
                        this.toast.clear();
                    }
                },
                deep: true,
            },
        },
        methods: {
            formatter(type, val) {
                if (type === 'year') {
                    return `${val}年`;
                } else if (type === 'month') {
                    return `${val}月`;
                
                } else if (type === 'day') {
                    return `${val}日`;
                }
                if (type === 'day' && val > 25 ) {
                    val = ''
                }
                return val;
            },
            timeChange(i){
                this.timeId = i
                this.showPicker = true
               
            },
            //关闭弹窗
            closeHan() {
                this.$emit('closePage')
            },
            //传过来的ID
            getData(i,id){
                console.log(id)
                this.idsInfo = id
                // if(id == 2){
         
                // }
                this.getdataInfo(i)
                this.infoId = i.id
                if (this.isWechat) {
                    this.wcConfig();
                };
            },
            //获取
            async getdataInfo(i){
                var toast = Toast.loading({
                        duration: 0, // 持续展示 toast
                        forbidClick: true,
                        message: "加载中..."
                    });
                try {
                    const {data} = await getZhbInfo({id:i.id}).then(res=>res)
                    toast.clear()//清除加载效果
                this.form ={...this.form,...data.data}
                    if(data.data.main_photo){
                        this.$refs.imgChangeRef1.setChange(data.data.main_photo)
                        // this.fileList1 = [{url:data.data.main_photo}]

                        this.imageUrl = data.data.main_photo
                    }
                    if(data.data.vehicle_tag){
                        this.$refs.imgChangeRef2.setChange(data.data.vehicle_tag)
                        // this.fileList2 = [{url:data.data.vehicle_tag}]
                        this.VinUrl = data.data.vehicle_tag
                    }
                    if(data.data.photos && data.data.photos instanceof Array){
                        this.WXimg = data.data.photos
                        this.$refs.imgChangeRef3.setChange(data.data.photos)
                    }
                   
                    // if(data.data.photos.length!=0){
                    //     let obj = {}
                    //     let arr = []
                    //     data.data.photos.forEach(i=>{
                    //         obj = {url:i}
                    //         arr.push(obj)
                    //     })
                    //     this.imageFile = arr
                    // }
                } catch (error) {
                    toast.clear()//清除加载效果
                }
                
            },
            closeArr(index){
                this.WXimg.splice(index, 1)
                // this.WXimg = data
            },
            imagesUrl(data){
                console.log(arguments,1)
                if(data.type == 1){
                    this.imageUrl = data.url
                }else if(data.type == 2){
                    // this.VinUrl = data.url
                    this.getmingImg(data.url)
                }else if(data.type == 3){
                    this.WXimg.push(data.url)

                }
            },
            //提交
            async onSubmit(){
                console.log(this.WXimg,'this.WXimg')
                this.form.photos = this.WXimg
                if(this.form.photos.length==0){
                    Toast('请上传多张照片')
                    return false
                }
                this.form.id = this.infoId
        
              
                this.form.main_photo = this.imageUrl
                this.form.vehicle_tag = this.VinUrl
                var toast = Toast.loading({
                        duration: 2000, // 持续展示 toast
                        forbidClick: true,
                        message: "加载中..."
                    });
                try {
                    const data = await zhbAdd(this.form).then(res=>res)
                    console.log(data)
                    toast.clear()//清除加载效果
                    this.$emit('closePage')
                } catch (error) {
                    toast.clear()//清除加载效果
                }
                
            },
            //时间
            onConfirm(time) {
                let date = moment(new Date()).format('YYYYMMDD')
                let NewDate = moment(time).format('YYYYMMDD')
                if(date >= NewDate){
                    console.log(123)
                    Toast({ duration: 2000,message:'时间必须大于今天'});
                    return false

                }

                if(this.timeId == 1){
                    this.form.sales_deadline = moment(time).format('YYYY-MM-DD')
                }else if(this.timeId == 2){
                    this.form.dismantling_deadline = moment(time).format('YYYY-MM-DD')
                }
                this.showPicker = false;
            },
            //删除
            deleteimg(i){
                if(i=='zhu'){
                    this.form.main_photo = ''
                }else if(i=='min'){
                     this.form.vehicle_tag = ''
                }
               
            },
            // //删除
            // deleteimg2(file, datail) {

            //     this.imageFile.forEach((item, index) => {
            //         if (index == datail.index) {   // 判断删除的下标是否正确
            //             this.imageFile.splice(index, 1) // 使用遍历找到的index去数组里面删除
            //         }
            //     })
            //     this.WXimg.forEach((item, index) => {
            //         if (index == datail.index) {   // 判断删除的下标console.log(this.WXimg)
            //             this.WXimg.splice(index, 1) // 使用遍历找到的index去数组里面删除
            //         }
            //     })
            // },
            //  // 上传照片
            // uploadershang(i) {
            //     return file => {
            //         file.status = "uploading";
            //         file.message = "上传中...";
            //         if (file instanceof Array) {
            //             file.forEach(item => {

            //                 this.upImages(i, item)

            //                 console.log(i)
            //             })
            //         } else {
            //             this.upImages(i, file)
            //         }
            //     }
            // },
            // upImages(i, file) {
            //     file.status = "uploading";
            //     file.message = "上传中...";
            //     let params = new FormData(); //创建form对象
            //     params.append("file", file.file);
            //     this.$http.post("/index.php/index/upload/index", params)
            //         .then((res) => {
            //             // toast.clear()//清除加载效果
            //             if (res.data.code == 0) {
            //                 file.status = "done";
            //                 if (i == 'zhu') {
            //                     this.form.main_photo = res.data.data
            //                     this.imageUrl = res.data.data
            //                 } else if (i == 'min') {
            //                     // this.form.vehicle_tag = res.data.data
            //                     this.getmingImg(res.data.data)
            //                 } else  if (i == 'restsImg') {
            //                     this.WXimg.push(res.data.data)
                            
                               
            //                 }
                       
            //             } else if (res.data.code == -1) {
            //                 deleteCookie('token')
            //                 this.$toast.fail(res.data.msg)
            //                 this.$router.push('/')
            //             } else {
            //                 file.status = "failed";
            //                 file.message = "上传失败";
            //                 this.$toast.fail(res.data.msg)
            //             }
            //         }).catch(() => {
            //             if (i == 'zhu') {
            //                 this.form.main_photo = ''
            //                 this.fileList1 = []
            //             } else if (i == 'min') {
            //                 // this.form.vehicle_tag = ''
            //                 this.fileList2 = []
            //             } else if (i == 'restsImg') {
            //                 this.imageFile = []
            //             }else 
            //             // toast.clear()//清除加载效果
            //             file.status = "failed";
            //             file.message = "上传失败";
            //             this.$toast.fail('网络开小差了，请稍后重试！')
            //         })
            // },
       
            async getmingImg(img){
                try {
                    var toast = Toast.loading({
                        duration: 0, // 持续展示 toast
                        forbidClick: true,
                        message: "加载中..."
                    });
                    
                    const data = await zhbIdentify({url:img}).then(res=>res)
                    toast.clear()//清除加载效果
              
                    // this.fileList2 = []
                    // this.fileList2 = [{url:data.data.data}]
                    // this.form.vehicle_tag = data.data.data
                    // let a = JSON.stringify(this.form)
                    // console.log(a)

                    this.VinUrl = data.data.data
                    this.$refs.imgChangeRef2.setChange(data.data.data)
                } catch (error) {
                    this.VinUrl = img
                    toast.clear()//清除加载效果
                }
               
            }
        },
    }
</script>

<style lang="scss" scoped>
.header {
    position: fixed;
    top: 0;
    z-index: 9;
    width: calc(100% - 40px);
    padding: 0 20px;
    background-color: cadetblue;
    height: 1rem;
    line-height: 1rem;
    color: white;
    font-size: 0.4rem;
    display: flex;
    justify-content: space-between;
    span {
        display: inline-block;
    }
    span:nth-child(1) {
        // width: 30px;
        // height: 30px;
        // background-image: url(../../assets/u39.png);
        // background-size: 100%;
        // margin-top: 8px;
    }
}
.con{
    padding-top: 50px;
}
.upimg {
    padding: 0 12px;

    .uploaderImg {
        display: inline-block;
        width: 100px;
        height: 100px;
        border: 1px solid #eee;
        position: relative;

        .iconz {
            position: absolute;
            top: 42%;
            left: 38%;

        }
    }
}
</style>